// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1GKup","label":"Labeled_label__1R3H_","divider":"Labeled_divider__3q6uQ"};